import React from "react";

const RuneMarketPopup = ({ data, closePopup }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-gray-800 p-4 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-pink-500">
            {data.name} ({data.ticker})
          </h2>
          <button
            onClick={closePopup}
            className="text-gray-400 hover:text-white"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <p>
              <strong>Price:</strong> {data.priceFormatted} sats
            </p>
            <p>
              <strong>Market Cap:</strong> {data.marketCap} BTC
            </p>
            <p>
              <strong>Total Supply:</strong> {data.totalSupply}
            </p>
            <p>
              <strong>Divisibility:</strong> {data.divisibility}
            </p>
            <p>
              <strong>Holder Count:</strong> {data.holderCount}
            </p>
            <p>
              <strong>Pending Txns:</strong> {data.pendingTxnCount}
            </p>
            <p>
              <strong>Rune Number:</strong> {data.runeNumber}
            </p>
          </div>
          <div>
            <p>
              <strong>Volume (1d):</strong> {data.volume1d} BTC
            </p>
            <p>
              <strong>Volume (7d):</strong> {data.volume7d} BTC
            </p>
            <p>
              <strong>Volume (30d):</strong> {data.volume30d} BTC
            </p>
            <p>
              <strong>Volume (All):</strong> {data.volumeAll} BTC
            </p>
            <p>
              <strong>Δ Floor (1d):</strong> {data.deltaFloor1d}%
            </p>
            <p>
              <strong>Δ Floor (7d):</strong> {data.deltaFloor7d}%
            </p>
            <p>
              <strong>Δ Floor (30d):</strong> {data.deltaFloor30d}%
            </p>
          </div>
        </div>
        {data.imageURI && (
          <div className="mt-4">
            <img
              src={data.imageURI}
              alt={data.name}
              className="max-w-full h-auto rounded"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default RuneMarketPopup;
